import { SideImage } from '../../components/SideImage';
import { GolfBookingContent } from '../../composites/GolfBookingContent';
import { SplitLayout } from '../../composites/SplitLayout';
import type { GolfBookingFormProps } from './GolfBookingForm.types';

export function GolfBookingForm({
  imageUrl,
  imageAlt,
  onBack,
  labels,
  ...contentProps
}: GolfBookingFormProps) {
  const { title, subtitle, noteText, backLabel, calendar, ...contentLabels } = labels;

  return (
    <SplitLayout
      left={
        <SideImage src={imageUrl} alt={imageAlt} sticky onBack={onBack} backLabel={backLabel} />
      }
      right={
        <GolfBookingContent
          {...contentProps}
          title={title}
          subtitle={subtitle}
          noteText={noteText}
          onBack={onBack}
          calendarLabels={calendar}
          labels={contentLabels}
        />
      }
      contentGap="0px"
      contentMaxWidth="100%"
      hideLeftOnMobile
    />
  );
}
